// extracted by mini-css-extract-plugin
export default {"default":"ImageUnavailable___imageUnavailable-module__default___yn07f"};